export default class BillingIssues {
  static PAYMENT_FAILED = "payment_failed";

  static SUBSCRIPTION_CANCELED = "subscription_canceled";
}
